import I18n from '@app/adapters/I18n'

export default function (): void {
  window.I18n = I18n
  I18n.defaultLocale = 'en'
  I18n.fallbacks = true
}
